// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__7dIj9","white":"Footer_white__2AXsu","black":"Footer_black__1Mfha","logo":"Footer_logo__3b2YI","link":"Footer_link__9_ojg","text":"Footer_text__2zIhj"};